import React, {useState} from "react";
import {Card, Input, Button, Link, Loading} from "@nextui-org/react";
import {MDBContainer, MDBRow} from "mdbreact";
import { MDBCardBody, MDBCol } from 'mdbreact';
import shopped from "../images/shopped.png"
import {Form} from "antd";
import Firebase from "../Firebase/Firebase";
import {getFunctions, httpsCallable} from "firebase/functions";
import {useToast} from "@chakra-ui/react";


const functions = getFunctions(Firebase);
const sendAdminPasswordReset = httpsCallable(functions, 'sendAdminPasswordReset');

const ForgotPassword = () => {
    const toast = useToast();
    const [loading, setLoading] = useState(false);
    const [sent, setSent] = useState(false);

    const handleSubmit = async (values: any) => {
        setLoading(true);
        try {
            await sendAdminPasswordReset({ email: values.email });
            setSent(true);
            toast({
                position: 'top',
                title: 'Reset email sent',
                description: 'If that email belongs to an admin account you will receive a password reset link shortly.',
                status: 'success',
                duration: 6000,
                isClosable: true,
            });
        } catch (err: any) {
            toast({
                position: 'top',
                title: 'Failed to send reset email',
                description: err.message ?? 'Please try again.',
                status: 'error',
                duration: 5000,
                isClosable: true,
            });
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="vh-100 bg">
            <MDBContainer>
                <MDBRow justify={"center"} align={"center"} center={true}>
                    <MDBCol md="12" className="my-5">
                        <Card style={{width:"25rem"}} isHoverable className="my-5 p-2">
                            <MDBCardBody>
                                <img src={shopped} style={{width:"15rem", height:"3.5rem"}}
                                     className="rounded mx-auto mb-5 d-block" alt="Shopped"/>

                                {sent ? (
                                    <div style={{textAlign:'center', padding:'12px 0'}}>
                                        <div style={{fontSize:32, marginBottom:10}}>✉️</div>
                                        <p style={{fontWeight:600, color:'#29327b', marginBottom:6}}>
                                            Check your inbox
                                        </p>
                                        <p style={{fontSize:13, color:'#666', marginBottom:20}}>
                                            A password reset link has been sent to your email address.
                                            The link expires in 1 hour.
                                        </p>
                                        <Link href="/">Back to Login</Link>
                                    </div>
                                ) : (
                                    <>
                                        <p style={{fontSize:13, color:'#666', marginBottom:16, textAlign:'center'}}>
                                            Enter your admin email address and we'll send you a reset link.
                                        </p>
                                        <Form onFinish={handleSubmit}>
                                            <Form.Item
                                                name="email"
                                                rules={[
                                                    {required: true, message: 'Please enter your email'},
                                                    {type: 'email', message: 'Not a valid email address'},
                                                ]}
                                            >
                                                <Input
                                                    type="email"
                                                    size="lg"
                                                    aria-label="email"
                                                    width="100%"
                                                    onChange={() => {}}
                                                    placeholder="Your admin email address"
                                                    className="my-1"
                                                />
                                            </Form.Item>
                                            <Button shadow disabled={loading} type="submit"
                                                    className="w-100 bg-indigo-500 my-4">
                                                {loading
                                                    ? <Loading type="spinner" color="currentColor" size="sm"/>
                                                    : <>Send Reset Link</>
                                                }
                                            </Button>
                                        </Form>
                                        <div className="text-center text-black-50 d-flex justify-content-center">
                                            Go back to Login &nbsp;<Link href="/">click here</Link>
                                        </div>
                                    </>
                                )}
                            </MDBCardBody>
                        </Card>
                    </MDBCol>
                </MDBRow>
            </MDBContainer>
        </div>
    );
};

export default ForgotPassword;
